import { render, staticRenderFns } from "./DefaultPackageImage.vue?vue&type=template&id=5209697d&scoped=true&"
import script from "./DefaultPackageImage.vue?vue&type=script&lang=js&"
export * from "./DefaultPackageImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5209697d",
  null
  
)

export default component.exports